export default __webpack_public_path__ + "static/media/health-check.c6f84943.png";